// extracted by mini-css-extract-plugin
export default {"spinner":"SpinnerOverlay_spinner__qETvS"};